exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-50496f34] .el-tabs__header {\n  margin-bottom: 0;\n}\n.info-box[data-v-50496f34]{\n  max-height: 1.06667rem;\n}\n.scan-code_btn[data-v-50496f34]{\n  padding: 0.05333rem 0.05333rem 0 0;\n  border-bottom: 0.01333rem solid #E4E7ED;\n}\n", ""]);

// exports
